$(document).ready(function(){

	// fix menu highlighting on retreats/category template
	if ($('body').hasClass('tax-retreats-cat')) {
		$('.primary-nav li:contains("Retreats")').addClass('current_page_parent');
	}

	// match height on grid items
	$('.match-height').matchHeight();

	// responsive video embeds
	$('iframe').wrap('<div class="video-wrapper" />');

	// remove image width and height attributes from images
	$('img').each(function(){
		if ($(this).is('[width]')) {
			$(this).removeAttr('width');
		}
		if ($(this).is('[height]')) {
			$(this).removeAttr('height');
		}
	});

	// toggle mobile menu
	$('.hamburger').click(function(e){
		$('body').toggleClass('mobile-nav-active');
	});

	// tour grid layout
	$('.tour-grid-group').masonry({
		itemSelector: '.tour-grid-item',
		columnWidth: '.tour-grid-item-sizer',
		percentPosition: true,
	});

	// instagram feed
	var Spectra = {
		instaToken: '251017741.6f7c669.15094800198e468bb85a69a91d306377',
		instaID: '251017741',
		init: function () {
			$.fn.spectragram.accessData = {
				accessToken: this.instaToken,
				clientID: this.instaID
			};
			$('#instagram-feed').spectragram('getUserFeed',{
				max: 12,
				query: 'campwandawega',
				size: 'big',
				wrapEachWith: '<li />'
			});
		}
	}
	Spectra.init();

	// insta carousel
	$('.insta-carousel').each(function(index, carousel) {
		if ($(carousel).children().length > 1) {
			var slider = $(carousel).flickity({
				adaptiveHeight: true,
				draggable: true,
				dragThreshold: 10,
				imagesLoaded: true,
				lazyLoad: 1,
				pageDots: false,
				percentPosition: true,
				wrapAround: false
			});

			// slider.on('change.flickity', function(event, index) {
			// 	console.log(index);
			// 	var current_slide = slider.flickity('select', index);
			// 	console.log('current_slide:', current_slide);
			// });

			// pause the video if you're navigating away from one
			// $(carousel).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			// 	var current_slide = $(slick.$slides.get(currentSlide));
			// 	var next_slide = $(slick.$slides.get(nextSlide));
			// 	var video = $(current_slide).find('video');
			// 	if (video.length > 0) {
			// 		$(video).trigger('pause');
			// 	}
			// });
		}
	});

	// case study layout alternating styles
	var browserWidth = $(window).width();

	// timeline layout alternating styles
	if (browserWidth > 640) {
		$('.event-even').each(function(){
			$('.event-text', this).insertBefore($('.event-year', this));
		});
	}
	$(window).resize(function(){
		var browserWidth = $(window).width();
		if (browserWidth > 640) {
			$('.event-even').each(function(){
				$('.event-text', this).insertBefore($('.event-year', this));
			});
		} else {
			$('.event-even').each(function(){
				$('.event-year', this).insertBefore($('.event-text', this));
			});
		}
	});

	// photo gallery modals
	$('.photo-gallery-modals').magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-with-zoom',
		zoom: {
			enabled: true,
			duration: 300,
			easing: 'ease-in-out',
			opener: function(openerElement) {
				return openerElement.is('img') ? openerElement : openerElement.find('img');
			}
		},
		gallery: {
			enabled: true,
			preload: [1,2],
			arrowMarkup: '<button type="button" title="%title%" class="mfp-custom-arrow mfp-custom-arrow-%dir%"><i class="fa fa-angle-%dir% mfp-prevent-close"></i></button>',
			tPrev: 'Previous',
			tNext: 'Next',
		},
		disableOn: 640,
	});

	// video modals
	$('.video-modal').magnificPopup({
		type: 'iframe',
		removalDelay: 300,
		mainClass: 'mfp-fade',
		disableOn: 640,
	});

	$('.image-modal').magnificPopup({
		type: 'image',
		removalDelay: 300,
		mainClass: 'mfp-fade',
		disableOn: 640,
	});

	// frequently asked questions
	$('.question-title').click(function(e){
		e.preventDefault();
		$(this).parent('.question').toggleClass('active');
	});

	// social share pop-ups
	function windowPopup(url, width, height) {
		var left = (screen.width / 2) - (width / 2);
		var top = (screen.height / 2) - (height / 2);
		window.open(
			url,
			"",
			"menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
		);
	}

	$('.social-share-trigger').on('click', function(e){
		e.preventDefault();
		windowPopup($(this).attr('href'), 500, 300);
	});

	// ajax contact form
	var eventForm = $('#event-form');
	var eventFormMessages = $('#event-form-messages');

	$(eventForm).submit(function(e){
		e.preventDefault();
		var eventFormData = $(eventForm).serialize();
		$.ajax({
			type: 'POST',
			url: $(eventForm).attr('action'),
			data: eventFormData,
		})
		.done(function(response){
			$(eventFormMessages).removeClass('form-messages-error');
			$(eventFormMessages).addClass('form-messages-success');
			$(eventFormMessages).text(response);
			$(eventForm).addClass('form-hidden');
		})
		.fail(function(data){
			$(eventFormMessages).removeClass('form-messages-success');
			$(eventFormMessages).addClass('form-messages-error');
			if (data.responseText !== '') {
				$(eventFormMessages).text(data.responseText);
			} else {
				$(eventFormMessages).text('Oh no! Your message could not be sent.');
			}
		});
	});

});
